$('.catalogue_checkbox').change(function () {
  if ($('.catalogue_checkbox').prop('checked') == true) {
    document
      .querySelector('.prefectures_required')
      .setAttribute('required', '');
    document.querySelector('.prefectures_required_text').style.display =
      'inline-block';
    document.querySelector('.prefectures_optional_text').style.display = 'none';
  } else {
    document
      .querySelector('.prefectures_required')
      .removeAttribute('required', '');
    document.querySelector('.prefectures_required_text').style.display = 'none';
    document.querySelector('.prefectures_optional_text').style.display =
      'inline-block';
  }
});
